import produce from 'immer';
import {
  ADD_FILE_SUCCESS,
  ADD_IMAGE,
  CLEAR_POST,
  CONNECT_FOLDER_SUCCESS,
  COPY_MOVE_POST_SUCCESS,
  CREATE_POST,
  CREATE_POST_SUCCESS,
  FETCH_FOLDER_SUCCESS,
  FETCH_FOLDERS,
  FETCH_FOLDERS_FAILED,
  FETCH_FOLDERS_SUCCESS,
  FETCH_POST,
  FETCH_POST_GALLERY,
  FETCH_POST_GALLERY_SUCCESS,
  FETCH_POST_SUCCESS,
  FETCH_POSTS,
  FETCH_POSTS_SUCCESS,
  FETCH_WEEKLY_SUCCESS,
  UPDATE_EDIT,
  UPDATE_POST,
  UPDATE_POST_SUCCESS,
  UPDATE_STATE,
} from 'actions/postActions';

import {CONNECT_POST_SUCCESS} from 'actions/competitionActions';
import {formatFilesForSetka} from '../utils/setka';

export const initialState = {
  list: [],
  fetching: false,
  fetchSuccess: false,
  fetchFailed: false,
  statusText: null,
  submitting: false,
  createSuccess: false,
  createFailed: false,
  createError: '',
  newPost: null,
  active: null,
  postImageFiles: [],
  postCustomLibraryFiles: [],
  statuses: {
    all: 0,
    mine: 0,
    trash: 0,
    draft: 0,
    finished: 0,
    deactivated: 0,
    published: 0,
    scheduled: 0,
  },
  weekly: [],
  folderConnected: false,
  folders: [],
  total: 0,
  insideFolder: null,
  totalPosts: 0,
  pageNumberNew: 0,
  updateAction: null,
  path: [],
};

/* eslint-disable default-case, no-param-reassign */
const postsReducer = (state = initialState, action) =>
  // eslint-disable-next-line consistent-return
  produce(state, (draft) => {
    switch (action.type) {
      case FETCH_POSTS:
        draft.fetching = true;
        draft.fetchSuccess = false;
        draft.fetchFailed = false;
        // draft.list = [];
        break;
      case CLEAR_POST:
        draft.active = null;
        break;
      case FETCH_POSTS_SUCCESS:
        draft.fetching = false;
        draft.fetchSuccess = true;
        draft.fetchFailed = false;
        draft.list = action.posts;
        draft.statuses = action.statuses;
        draft.totalPosts = action.total;
        draft.pageNumberBack = action.pageNumberBack;
        break;
      case UPDATE_EDIT:
        draft.list = draft.list.map((post) => {
          if (post._id === action.details._id && !action.details.status) {
            if (!post.isEditingAt || post.isEditingAt < action.details.at) {
              post.isEditingAt = action.details.at;
              post.isEditing = action.details.isEditing;
            }
          } else if (post._id === action.details._id && action.details.status) {
            if (!post.statusAt || post.statusAt < action.details.at) {
              post.statusAt = action.details.at;
              post.status = action.details.status;
            }
          }
          return post;
        });
        break;
      case UPDATE_POST:
        // Reset to empty before send, then update success setup the action can get music even it's repeat click.
        draft.updateAction = '';
        break;
      case UPDATE_POST_SUCCESS:
        if ((!action.post?._id && action.postId) || action.post?.isDeleted) {
          const postId = action.post._id ? action.post._id : action.postId;
          draft.list = draft.list.filter((post) => post._id !== postId);
          // draft.list = draft.list.map(post => {
          //   const childPosts = post.childPosts.filter(child =>
          //     child._id !== postId,
          //   );
          //   returnPost = { ...post, childPosts };
          // });
        } else {
          // draft.list = draft.list.map(post => {
          //   const isExisting = post._id === action.post._id;
          //   if (isExisting) {
          //     return { ...action.post, featuredImage: post.featuredImage, childPosts: post.childPosts };
          //   }
          //   const childPosts = post.childPosts.map(child =>
          //     child._id === action.post._id ? { ...action.post, featuredImage: child.featuredImage } : child,
          //   );
          //   returnPost = { ...post, childPosts };
          // });
        }
        if (
          action.post.details.action !== undefined &&
          action.post.details.action !== ''
        ) {
          draft.updateAction = action.post.details.status;
        }
        // return returnPost;
        break;

      case CONNECT_POST_SUCCESS:
        draft.list = draft.list.map((p) =>
          p._id === action.postId
            ? {
                ...p,
                competitionId: action.remove ? null : action.competition._id,
              }
            : {
                ...p,
                childPosts: p.childPosts.map((cc) =>
                  cc._id === action.postId
                    ? {
                        ...cc,
                        competitionId: action.remove
                          ? null
                          : action.competition._id,
                      }
                    : cc
                ),
              }
        );

        break;
      case FETCH_WEEKLY_SUCCESS:
        draft.weekly = action.posts;
        break;
      case FETCH_POST:
        draft.fetching = true;
        draft.fetchSuccess = false;
        draft.fetchFailed = false;
        draft.active = null;
        break;
      case FETCH_POST_SUCCESS:
        draft.fetching = false;
        draft.fetchSuccess = true;
        draft.fetchFailed = false;
        draft.active = action.post;
        break;
      case CREATE_POST:
        draft.submitting = true;
        draft.createSuccess = false;
        draft.newPost = null;
        break;
      case CREATE_POST_SUCCESS:
        draft.submitting = true;
        draft.createSuccess = true;
        draft.newPost = action.post;
        break;

      case UPDATE_STATE:
        draft.submitting = false;
        draft.createSuccess = false;
        draft.newPost = null;
        draft.active = null;
        break;

      case FETCH_POST_GALLERY:
        draft.postImageFiles = [];
        draft.postCustomLibraryFiles = [];
        draft.fetchingGallery = true;
        break;

      case FETCH_POST_GALLERY_SUCCESS:
        draft.fetchingGallery = false;
        // console.log('fetch gallery success', [...action.folders]);
        draft.postImageFiles = formatFilesForSetka(action.folders);
        draft.postCustomLibraryFiles = formatFilesForSetka(action.extraFolders);
        // console.log('fetch gallery success 2', draft.postImageFiles);
        break;
      case CONNECT_FOLDER_SUCCESS:
        draft.folderConnected = true;
        break;
      case ADD_IMAGE:
        draft.postImageFiles.push(action.image);
        break;
      case COPY_MOVE_POST_SUCCESS:
        if (action.isCopy) {
          draft.list = draft.list.map((single) =>
            single._id === action.id
              ? {
                  ...single,
                  childPosts: [
                    ...single.childPosts,
                    {
                      ...action.post,
                      featuredImage: single.featuredImage,
                      // createdBy: single.createdBy, // Should use current user.
                    },
                  ],
                }
              : single
          );
        } else {
          draft.list = draft.list.filter((f) => f._id !== action.id);
        }
        break;

      case FETCH_FOLDERS:
        draft.fetching = true;
        draft.fetchSuccess = false;
        draft.fetchFailed = false;
        draft.folders = [];

        break;

      case FETCH_FOLDERS_SUCCESS:
        draft.fetching = false;
        draft.fetchSuccess = true;
        draft.fetchFailed = false;
        draft.folders = action.folders;
        draft.total = action.total;
        draft.insideFolder = action.folder;
        draft.path = action.path;
        break;

      case FETCH_FOLDERS_FAILED:
        draft.fetching = false;
        draft.fetchSuccess = false;
        draft.fetchFailed = true;
        draft.statusText = action.statusText;
        break;
      case ADD_FILE_SUCCESS:
        draft.folders.push(action.file);
        break;
      case FETCH_FOLDER_SUCCESS:
        draft.insideFolder = action.folder;
        break;
    }
  });

export default postsReducer;
